@if (!isLoading()) {
  <div class="row-container">
    <form [formGroup]="formGroup()">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true" class="mat-elevation-z0 section-box">
          <mat-expansion-panel-header class="section-header">
            <mat-panel-title class="section-title">
              <h3>{{ mainInformationText }}</h3>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row row-2 bottom-row">
            <div class="item">
              <app-input formControlName="name" [label]="translations.nameLabel"></app-input>
            </div>
            <div class="item">
              <app-input
                formControlName="description"
                [label]="translations.descriptionLabel"
              ></app-input>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion>
        <mat-expansion-panel [expanded]="true" class="mat-elevation-z0 section-box">
          <mat-expansion-panel-header class="section-header">
            <mat-panel-title class="section-title">
              <h3>
                <ng-container i18n="@@shared.criteria">Criteria</ng-container>
                <mat-icon class="help-icon" [tp]="translations.criteriaTp">help</mat-icon>
              </h3>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <p class="dark-gray no-margin-top">
            <small>
              {{ translations.noCriteriaHint }}
            </small>
          </p>
          <app-ruleset-criteria
            (addCriteria)="addCriteria.emit($event)"
            [locationOptions]="locationOptions()"
            [locationTypeOptions]="locationTypeOptions()"
            [countryOptions]="countryOptions()"
            [propertyOptions]="propertyOptions()"
            [formGroup]="conditionFormGroup"
          ></app-ruleset-criteria>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion>
        <mat-expansion-panel [expanded]="true" class="mat-elevation-z0 section-box">
          <mat-expansion-panel-header class="section-header">
            <mat-panel-title class="section-title">
              <h3>
                <ng-container i18n="@@shared.expectations">Expectations</ng-container>
                <mat-icon class="help-icon" [tp]="translations.expectationsTp">help</mat-icon>
              </h3>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <p class="dark-gray">
            <small>
              {{ translations.specifyDocument }}
            </small>
          </p>
          <ng-content></ng-content>
        </mat-expansion-panel>
      </mat-accordion>
    </form>
  </div>
}
